<template>
  <div
    :class="`UIModalOverlay UIModalOverlay--${size}`"
    :style="{ clipPath: clipPathStyle }"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { IUIModalSizes } from './types'

/**
 * Config for making a 'hole' in the modal overlay
 */
export interface IModalSpotlightonfig {
  top: number
  left: number
  width: number
  height: number
}

const props = withDefaults(
  defineProps<{
    size?: IUIModalSizes
    spotlightConfig?: IModalSpotlightonfig
  }>(),
  {
    size: 'md',
  },
)

// Compute the clip-path based on spotlightConfig
const clipPathStyle = computed(() => {
  if (!props.spotlightConfig) {
    return undefined
  }

  const { top, left, width, height } = props.spotlightConfig
  const right = left + width
  const bottom = top + height

  // Create a polygon that covers the entire viewport but excludes the spotlight area
  return `polygon(
    evenodd,
    0% 0%,
    0% 100%,
    100% 100%,
    100% 0%,
    0% 0%,
    ${left}px ${top}px,
    ${left}px ${bottom}px,
    ${right}px ${bottom}px,
    ${right}px ${top}px,
    ${left}px ${top}px
  )`
})
</script>

<style scoped lang="scss">
.UIModalOverlay {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  // $color-neutral-170 with opacity 70%
  background-color: #09092d4d;
  z-index: 1999;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.3s ease;

  &.UIModalOverlay--full {
    top: $topbar-height;
    height: calc(100vh - $topbar-height);
    background-color: $color-neutral-5;
    align-items: unset;
  }
}
</style>
